import { useState, useEffect } from 'react';
import apiFetch from '@wordpress/api-fetch';
import Toggle from './toggle/Toggle';
import FilterToggle from './filterToggle/FilterToggle';
import FilterButton from './filterButton/FilterButton';
import './EventArchive.css';
import Button from './button/Button';

const eventType = {
	stay: 'Stay',
	dine: 'Dine',
	rejuvenate: 'Rejuvenate',
	celebrate: 'Celebrate',
	discover: 'Discover',
	general: 'General',
};

const shortMonth = {
	jan: 'Jan',
	feb: 'Feb',
	mar: 'Mar',
	apr: 'Apr',
	may: 'May',
	jun: 'Jun',
	jul: 'Jul',
	aug: 'Aug',
	sep: 'Sep',
	oct: 'Oct',
	nov: 'Nov',
	dec: 'Dec',
};

export default function EventArchivePage() {
	const [posts, setPosts] = useState([]);
	const [results, setResults] = useState([]);
	const [filteredPosts, setFilteredPosts] = useState([]);
	const [filterBy, setFilterBy] = useState({
		type: '',
		month: '',
	});

	useEffect(() => {
		const fetchPosts = async () => {
			const data = await apiFetch({ path: '/dawn-ranch/events' });
			setPosts(data);
			setFilteredPosts(data);

			const results = {
				allCount: data.length,
				stayCount: 0,
				dineCount: 0,
				rejuvenateCount: 0,
				celebrateCount: 0,
				discoverCount: 0,
				generalCount: 0,
			};

			const monthResults = {
				janCount: 0,
				febCount: 0,
				marCount: 0,
				aprCount: 0,
				mayCount: 0,
				junCount: 0,
				julCount: 0,
				augCount: 0,
				sepCount: 0,
				octCount: 0,
				novCount: 0,
				decCount: 0,
			};

			data.forEach((event) => {
				if (event.types.includes(eventType.stay)) {
					results.stayCount += 1;
				} else if (event.types.includes(eventType.dine)) {
					results.dineCount += 1;
				} else if (event.types.includes(eventType.rejuvenate)) {
					results.rejuvenateCount += 1;
				} else if (event.types.includes(eventType.celebrate)) {
					results.celebrateCount += 1;
				} else if (event.types.includes(eventType.discover)) {
					results.discoverCount += 1;
				} else if (event.types.includes(eventType.general)) {
					results.generalCount += 1;
				}

				if (event.startMonth == shortMonth.jan) {
					monthResults.janCount += 1;
				} else if (event.startMonth == shortMonth.feb) {
					monthResults.febCount += 1;
				} else if (event.startMonth == shortMonth.mar) {
					monthResults.marCount += 1;
				} else if (event.startMonth == shortMonth.apr) {
					monthResults.aprCount += 1;
				} else if (event.startMonth == shortMonth.may) {
					monthResults.mayCount += 1;
				} else if (event.startMonth == shortMonth.jun) {
					monthResults.junCount += 1;
				} else if (event.startMonth == shortMonth.jul) {
					monthResults.julCount += 1;
				} else if (event.startMonth == shortMonth.aug) {
					monthResults.augCount += 1;
				} else if (event.startMonth == shortMonth.sep) {
					monthResults.sepCount += 1;
				} else if (event.startMonth == shortMonth.oct) {
					monthResults.octCount += 1;
				} else if (event.startMonth == shortMonth.nov) {
					monthResults.novCount += 1;
				} else if (event.startMonth == shortMonth.dec) {
					monthResults.decCount += 1;
				}
			});

			setResults({ ...results, ...monthResults });
		};

		fetchPosts();
	}, []);

	useEffect(() => {
		let filtered = [...posts];

		setFilteredPosts(
			filtered.filter((event) => {
				if (filterBy.type && filterBy.month) {
					return (
						event.types.includes(filterBy.type) &&
						event.startMonth === filterBy.month
					);
				} else if (filterBy.type) {
					return event.types.includes(filterBy.type);
				} else if (filterBy.month) {
					return event.startMonth === filterBy.month;
				} else {
					return true; // return all posts if no filters are applied
				}
			})
		);
	}, [filterBy]);

	return (
		<div className='event-page'>
			{posts && posts.length > 0 ? (
				<main className='event-main'>
					<FilterToggle
						results={results.allCount}
						onViewAllClick={() =>
							setFilterBy({
								type: '',
								month: '',
							})
						}
					>
						<div className='filter-section'>
							<div className='view-all-filter-wrapper'>
								<FilterButton
									onClick={() =>
										setFilterBy({
											type: '',
											month: '',
										})
									}
									filterBy={'VIEW ALL'}
									results={results.allCount}
								/>
								<div style={{ borderBottom: '1px solid #000' }} />
							</div>

							<div className='event-type-filter'>
								<h5 className='subtitle'>
									By Event Type{' '}
									<button
										className='clear-all-button'
										onClick={() =>
											setFilterBy({
												type: '',
												month: '',
											})
										}
									>
										Clear All{' '}
									</button>
								</h5>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: eventType.stay,
											month: prevState.month,
										}))
									}
									filterBy={eventType.stay}
									results={results.stayCount}
									isActive={filterBy.type === eventType.stay}
								/>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: eventType.dine,
											month: prevState.month,
										}))
									}
									filterBy={eventType.dine}
									results={results.dineCount}
									isActive={filterBy.type === eventType.dine}
								/>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: eventType.rejuvenate,
											month: prevState.month,
										}))
									}
									filterBy={eventType.rejuvenate}
									results={results.rejuvenateCount}
									isActive={filterBy.type === eventType.rejuvenate}
								/>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: eventType.celebrate,
											month: prevState.month,
										}))
									}
									filterBy={eventType.celebrate}
									results={results.celebrateCount}
									isActive={filterBy.type === eventType.celebrate}
								/>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: eventType.discover,
											month: prevState.month,
										}))
									}
									filterBy={eventType.discover}
									results={results.discoverCount}
									isActive={filterBy.type === eventType.discover}
								/>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: eventType.general,
											month: prevState.month,
										}))
									}
									filterBy={eventType.general}
									results={results.generalCount}
									isActive={filterBy.type === eventType.general}
								/>
							</div>

							<div className='event-type-filter'>
								<h5 className='subtitle'>
									By Date{' '}
									<button
										className='clear-all-button'
										onClick={() =>
											setFilterBy({
												type: '',
												month: '',
											})
										}
									>
										Clear All{' '}
									</button>
								</h5>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: prevState.type,
											month: shortMonth.jan,
										}))
									}
									filterBy={'JANUARY'}
									results={results.janCount}
									isActive={filterBy.month === shortMonth.jan}
								/>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: prevState.type,
											month: shortMonth.feb,
										}))
									}
									filterBy={'FEBRUARY'}
									results={results.febCount}
									isActive={filterBy.month === shortMonth.feb}
								/>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: prevState.type,
											month: shortMonth.mar,
										}))
									}
									filterBy={'MARCH'}
									results={results.marCount}
									isActive={filterBy.month === shortMonth.mar}
								/>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: prevState.type,
											month: shortMonth.apr,
										}))
									}
									filterBy={'APRIL'}
									results={results.aprCount}
									isActive={filterBy.month === shortMonth.apr}
								/>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: prevState.type,
											month: shortMonth.may,
										}))
									}
									filterBy={'MAY'}
									results={results.mayCount}
									isActive={filterBy.month === shortMonth.may}
								/>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: prevState.type,
											month: shortMonth.jun,
										}))
									}
									filterBy={'JUN'}
									results={results.junCount}
									isActive={filterBy.month === shortMonth.jun}
								/>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: prevState.type,
											month: shortMonth.jul,
										}))
									}
									filterBy={'JUL'}
									results={results.julCount}
									isActive={filterBy.month === shortMonth.jul}
								/>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: prevState.type,
											month: shortMonth.aug,
										}))
									}
									filterBy={'AUGUST'}
									results={results.augCount}
									isActive={filterBy.month === shortMonth.aug}
								/>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: prevState.type,
											month: shortMonth.sep,
										}))
									}
									filterBy={'SEPTEMBER'}
									results={results.sepCount}
									isActive={filterBy.month === shortMonth.sep}
								/>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: prevState.type,
											month: shortMonth.oct,
										}))
									}
									filterBy={'OCTOBER'}
									results={results.octCount}
									isActive={filterBy.month === shortMonth.oct}
								/>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: prevState.type,
											month: shortMonth.nov,
										}))
									}
									filterBy={'NOVEMBER'}
									results={results.novCount}
									isActive={filterBy.month === shortMonth.nov}
								/>
								<FilterButton
									onClick={() =>
										setFilterBy((prevState) => ({
											type: prevState.type,
											month: shortMonth.dec,
										}))
									}
									filterBy={'DECEMBER'}
									results={results.decCount}
									isActive={filterBy.month === shortMonth.dec}
								/>
							</div>
						</div>
					</FilterToggle>
					<div className='event-list-section'>
						{filteredPosts.length === 0 ? (
							<div className='no-events-message'>
								There are no {filterBy.type} events in the date range you
								selected. If you'd like to inquire about more events, please use
								the menu on the left, or reach out
							</div>
						) : (
							filteredPosts.map((post) => <Toggle key={post.id} post={post} />)
						)}
					</div>
				</main>
			) : (
				<div className='no-events-button-wrapper'>
					<Button onClick={() => {}} link='/events-contact'>inquire about events</Button>
				</div>
			)}
		</div>
	);
}
